import { Descriptions, Form, Table } from 'antd'
import FormSectionTitle from 'elements/FormSectionTitle'
import FileCell from 'elements/Table/Cells/FileCell'
import { get } from 'lodash'
import React from 'react'
import CustomSpin from '../../../elements/CustomSpin'

function EmailForm(props) {
  const { email, fetching } = props

  const { bounce } = email?.detail || {}

  return (
    <CustomSpin spinning={fetching}>
      <div className="mt-5">
        <Descriptions title="Address" bordered column={2}>
          <Descriptions.Item label="Subject" span={2}>
            {get(email, 'subject')}
          </Descriptions.Item>
          <Descriptions.Item label="From">{get(email, 'from')}</Descriptions.Item>
          <Descriptions.Item label="To">{get(email, 'to')}</Descriptions.Item>
          <Descriptions.Item label="cc">{get(email, 'cc')}</Descriptions.Item>
          <Descriptions.Item label="bcc">{get(email, 'bcc')}</Descriptions.Item>
        </Descriptions>
      </div>
      <div className="mt-5">
        <Descriptions title="Email Details" bordered column={2}>
          <Descriptions.Item label="Sender">{get(email, 'owner.fn')}</Descriptions.Item>
          {email?.lines?.map((i) => (
            <Descriptions.Item label="Document Code">{get(i, 'code')}</Descriptions.Item>
          ))}

          {email?.attachments?.map((i, index) => (
            <Descriptions.Item label={`Attachment ${index + 1}`}>
              <FileCell value={i._id} />
            </Descriptions.Item>
          ))}
        </Descriptions>
      </div>
      <div className="mt-5">
        <Descriptions title="Email Status" bordered column={2}>
          <Descriptions.Item label="Status">{get(email, 'detail.notificationType')}</Descriptions.Item>
          <Descriptions.Item label="Send Date">{get(email, 'detail.delivery.timestamp')}</Descriptions.Item>
          <Descriptions.Item label="messageId">{get(email, 'detail.mail.messageId')}</Descriptions.Item>
        </Descriptions>
      </div>

      {bounce && (
        <div className="mt-5">
          <FormSectionTitle title={'Bounce ADDRESS'}/>

          <Table
            dataSource={bounce?.bouncedRecipients}
            columns={[
              {
                title: 'emailAddress',
                dataIndex: 'emailAddress',
                key: 'emailAddress',
              },
              {
                title: 'action',
                dataIndex: 'action',
                key: 'action',
              },
              {
                title: 'diagnosticCode',
                dataIndex: 'diagnosticCode',
                key: 'diagnosticCode',
              },
            ]}
          />
        </div>
      )}
    </CustomSpin>
  )
}

export default Form.create()(EmailForm)
